import { MetaData } from '../../types/schemaTypes';

const schemaMixin = {
  methods: {
    jsonld(metaFields: MetaData, asPath: string): { [key: string]: unknown } | string | undefined {
      if (metaFields.pageSchema.length) {
        return metaFields.pageSchema.replace(/[\r\n]+\s*/g, '');
      } else if (asPath === '/') {
        return {
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Nixon Peabody Trust Company',
          url: metaFields.url,
          logo: metaFields.siteLogo,
          description: metaFields.description,
          sameAs: metaFields.socialMedia.map((item) => item),
          address: {
            '@type': 'PostalAddress',
            streetAddress: metaFields.address.streetAddress,
            addressLocality: metaFields.address.locality,
            addressRegion: metaFields.address.region,
            postalCode: metaFields.address.postalCode,
            addressCountry: metaFields.address.country,
          },
          parentOrganization: {
            '@type': 'Organization',
            name: 'Nixon Peabody LLP',
            url: 'https://www.nixonpeabody.com',
          },
        };
      } else if (asPath.startsWith('/services/')) {
        return {
          '@context': 'https://schema.org',
          '@type': 'LegalService',
          name: metaFields.title.split('|')[0].trim(),
          url: metaFields.url,
          description: metaFields.description,
          address: {
            '@type': 'PostalAddress',
            streetAddress: metaFields.address.streetAddress,
            addressLocality: metaFields.address.locality,
            addressRegion: metaFields.address.region,
            postalCode: metaFields.address.postalCode,
            addressCountry: metaFields.address.country,
          },
        };
      } else if (asPath.startsWith('/people/')) {
        return {
          '@context': 'https://schema.org',
          '@type': 'ProfilePage',
          mainEntity: {
            '@type': 'Person',
            name: metaFields.title.split('|')[0].trim(),
            description: metaFields.description,
            image: metaFields.personData.imageUrl,
            jobTitle: metaFields.personData.jobTitle,
            email: metaFields.personData.email,
            contactPoint: metaFields.personData.phoneNumbers.map((phone) => ({
              '@type': 'ContactPoint',
              contactType: phone.type,
              telephone: phone.number,
            })),
            worksFor: {
              '@type': 'Organization',
              name: 'Nixon Peabody Trust Company',
              url: 'https://www.nixonpeabodytrustcompany.com',
            },
            address: {
              '@type': 'PostalAddress',
              streetAddress: metaFields.address.streetAddress,
              addressLocality: metaFields.address.locality,
              addressRegion: metaFields.address.region,
              postalCode: metaFields.address.postalCode,
              addressCountry: metaFields.address.country,
            },
            url: metaFields.url,
          },
        };
      } else if (asPath.startsWith('/insights/')) {
        return {
          '@context': 'https://schema.org',
          '@type': 'Article',
          mainEntityOfPage: {
            '@type': 'WebPage',
            '@id': metaFields.url,
          },
          headline: metaFields.insightData.headline,
          description: metaFields.description,
          author: metaFields.insightData.authors.map((author) => ({
            '@type': 'Person',
            name: author.name,
            jobTitle: author.jobTitle,
            email: author.email,
          })),
          publisher: {
            '@type': 'Organization',
            name: 'Nixon Peabody Trust Company',
            logo: {
              '@type': 'ImageObject',
              url: metaFields.siteLogo,
            },
          },
          articleBody: metaFields.insightData.subheadline,
          isAccessibleForFree: true,
          inLanguage: 'en-US',
        };
      }

      return undefined;
    },
  },
};

export default schemaMixin;
